<div class="w-[40vw] lg:w-[16.666vw] h-[7.407vh] shadow-btn rounded-[2.777vh]" [style.backgroundColor]="backgroundColor" [class]="buttonCustomClass">
    <button class="w-full h-[7.407vh] flex items-center justify-center font-avantgarde font-bold text-[2.777vh] leading-[21.45px]" [style.color]="color"
   [ngClass]="{'!text-[14px]  !font-normal !leanding-[16.78px]': text === 'Riepilogo'}" [disabled]="isDisabled"
    >{{text}}</button>
</div>
